var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container bj-label-colon label-width-6 resize-col" },
    [
      _c(
        "BjDivider",
        {
          attrs: { "right-fixed": "" },
          scopedSlots: _vm._u([
            {
              key: "right",
              fn: function () {
                return [
                  _vm.info.status != 1
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.rePreemptOrderByNoticeId },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("PreoccupationManagement.view.reserve")
                            )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("el-button", { on: { click: _vm.handleClose } }, [
                    _vm._v(_vm._s(_vm.$t("backText"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _vm._v(
            _vm._s(_vm.$t("PreoccupationManagement.view.information")) + " "
          ),
        ]
      ),
      _c("div", { staticClass: "bj-row border-no padding-no mt20" }, [
        _c(
          "div",
          { staticClass: "bj-col bj-col-18 padding-no bj-item-col-12" },
          [
            _c(
              "el-form",
              { ref: "form", attrs: { inline: "" } },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("PreoccupationManagement.form.Third"),
                    },
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.info.outerOrderNo))]),
                    _c("BjCopyIcon", {
                      attrs: { copy: _vm.info.outerOrderNo },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("PreoccupationManagement.form.Internal"),
                    },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass: "link",
                        on: {
                          click: function ($event) {
                            return _vm.$toBusinessOrderInternalView(
                              _vm.info.innerOrderNo
                            )
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.info.innerOrderNo))]
                    ),
                    _c("BjCopyIcon", {
                      attrs: { copy: _vm.info.innerOrderNo },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("PreoccupationManagement.form.Three"),
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.info.orderTime) + " ")]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("PreoccupationManagement.form.order"),
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.info.creationDate) + " ")]
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: _vm.$t("PreoccupationManagement.form.order"),
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.info.predictDeliveryTime) + " ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass:
              "bj-col bj-col-6 padding-no flex-column flex-center el-progress-box-2022-4-11",
          },
          [
            _c("el-progress", {
              attrs: {
                type: "circle",
                width: 160,
                "stroke-width": 30,
                percentage: _vm.progressPercentage,
                format: _vm.progressText,
              },
            }),
          ],
          1
        ),
      ]),
      _c("BjDivider", [
        _vm._v(_vm._s(_vm.$t("PreoccupationManagement.view.preemptTitle"))),
      ]),
      _vm.tabVisible
        ? _c("GoodsInfoTab", {
            ref: "GoodsInfoTab",
            attrs: {
              "order-id": _vm.$route.query.id,
              "has-btn": "",
              success: _vm.info.status == 1,
            },
            on: { reFresh: _vm.reFresh },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }